import {
  ActionSheetController,
  ModalController,
  NavController,
  NavParams,
  ViewController,
  Platform,
  Events,
} from "ionic-angular";
import { Component } from "@angular/core";
import { Store } from "@ngrx/store";

//import { MarketContract } from '../../app/app.contract';
import { ContractsService } from "../../app/app.contract.service";
import { AppState } from "../../app/app.reducer";
import { AppUtilities } from "../../app/app.utilities";
import { ConfirmationPage } from "../confirmation/confirmation";
import { NodeService } from "../../services/node.service";
import { Token, TokenStatus, Transaction, Wallet } from "../../app/app.models";
import { TokensFetchAction } from "../../app/app.actions";
import { TokenofferPage } from "../tokenoffer/tokenoffer";
import { TokenbuyPage } from "../tokenbuy/tokenbuy";
import { TokeninfoPage } from "../tokeninfo/tokeninfo";
import { TokensellPage } from "../tokensell/tokensell";
import { TokensendPage } from "../tokensend/tokensend";
import { HomePage } from "../home/home";

import { WalletService } from "../../services/wallet.service";
import { ConfigService } from "../../services/config.service";
import { WatacardLoadingSerivce } from "../../services/watacard.loading.service";
import {
  NativePageTransitions,
  NativeTransitionOptions,
} from "@ionic-native/native-page-transitions";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "page-token",
  templateUrl: "token.html",
})
export class TokenPage {
  desktop: boolean;
  public token$: Token;
  public tokenofferPage = TokenofferPage;
  public tokenbuyPage = TokenbuyPage;
  public tokenmodalPage = TokeninfoPage;
  public tokensendPage = TokensendPage;
  public tokensellPage = TokensellPage;
  public wallet$: Wallet;
  ios: boolean;

  constructor(
    private contractService: ContractsService,
    public actionsheetCtrl: ActionSheetController,
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public nodeService: NodeService,
    public store: Store<AppState>,
    public utilities: AppUtilities,
    private loadingService: WatacardLoadingSerivce,
    private nativePageTransitions: NativePageTransitions,
    private configService: ConfigService,
    public viewCtrl: ViewController,
    private walletService: WalletService,
    private platform: Platform,
    private translateService: TranslateService,
    private events: Events
  ) {
    this.token$ = navParams.data;

    if (this.platform.is("core")) {
      this.desktop = true;
    } else {
      this.desktop = false;
    }

    if (this.platform.is("ios")) {
      this.ios = true;
    } else {
      this.ios = false;
    }

    this.ios = false;

    //this.getWallet();
    this.store.select("wallet").subscribe((wallet: Wallet) => {
      if (wallet && wallet.address) {
        this.wallet$ = wallet;
      }
    });
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad TokenPage");
  }

  ionViewWillEnter() {}

  openMenu() {
    let actionSheet = this.actionsheetCtrl.create({
      buttons: [
        {
          text: "Ver perfil del Vendedor",
          handler: () => {},
        },
        {
          text: "Cancel",
          role: "cancel",
        },
      ],
    });
    actionSheet.present();
  }

  openModal() {
    if (!this.desktop) {
      let options: NativeTransitionOptions = {
        direction: "right",
        duration: 600,
      };
      this.nativePageTransitions.flip(options);
      let modal = this.modalCtrl.create(TokeninfoPage, this.navParams.data, {
        showBackdrop: false,
      });

      modal.present();
    }
    if (this.desktop) {
      this.navCtrl.push(TokeninfoPage, this.navParams.data);
    }
  }

  showSellButtons(): boolean {
    return this.wallet$ && this.wallet$.address === this.token$.owner;
  }

  showBuyButtons(): boolean {
    return (
      this.wallet$ &&
      this.wallet$.address !== this.token$.owner &&
      this.token$.status === TokenStatus.ForSale
    );
  }

  statusForSale(): boolean {
    return this.token$.status === TokenStatus.ForSale;
  }

  cancelSell() {
    var tx = this.loadingService.getTempTx();
    if (tx) {
      this.nodeService
        .getTransactionTemp(tx)
        .then((result: any) => {
          if (result.blockNumber) {
            this.sendNewTransaction();
          } else {
            this.messageAlert();
          }
        })
        .catch((err) => {
          this.messageAlert();
        });
    } else {
      this.sendNewTransaction();
    }
  }

  sendNewTransaction() {
    var cancel_sale = this.translateService.instant("token.cancel_sale");
    var operation_not_execute = this.translateService.instant(
      "token.operation_not_execute"
    );
    var text;
    var idioma = this.configService.getIdiom();
    if (idioma == "en") text = "¿Are you sure you want to cancel this sale?";
    if (idioma == "es")
      text = "¿Estas seguro de que deseas cancelar esta venta?";

    this.utilities.confirm2(text, () => {
      let options = this.contractService.MarketContract.setAssetNotForSale.toPayload(
        [this.token$.assetId]
      );

      let transaction: Transaction = {
        from: this.wallet$.address,
        to: this.contractService.MarketContract.address,
        data: options.data,
      };

      var N = 1;
      this.nodeService
        .sendTransaction(transaction, true)
        .then((tx: any) => {
          if (tx !== "error") {
            this.loadingService.setTemp(tx, this.token$, this.token$.assetId);
            this.utilities.alert(cancel_sale);
            //this.navCtrl.setRoot(HomePage);
            this.events.publish("sellWatacard", true);
            this.navCtrl.popTo(
              this.navCtrl.getByIndex(this.navCtrl.length() - (N + 1))
            );
          }
          if (tx === "error") {
            this.utilities.alert(operation_not_execute);
            //this.navCtrl.setRoot(HomePage);
            this.events.publish("sellWatacard", true);
            this.navCtrl.popTo(
              this.navCtrl.getByIndex(this.navCtrl.length() - (N + 1))
            );
          }
        })
        .catch((error) => {
          var message = "Error: replacement transaction underpriced";
          this.utilities.alert(error);
          //this.navCtrl.setRoot(HomePage);
          this.events.publish("sellWatacard", false);
          this.navCtrl.popTo(
            this.navCtrl.getByIndex(this.navCtrl.length() - (N + 1))
          );
        });
    });
  }

  messageAlert() {
    var message_alert = this.translateService.instant("token.message_alert");
    this.utilities.alert(message_alert);
  }

  getWallet() {
    this.nodeService
      .getBalanceWatacoins()
      .then((wallet) => {
        this.wallet$ = wallet;
        console.log("Watacoins ", wallet);
      })
      .catch((err) => {
        console.log("err");
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/token/token.ts